import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import * as React from "react";

import { CommentRecord } from "@/shared/domain/comments";

interface DeleteCommentConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  comment: CommentRecord | null;
  onDelete: (commentId: string) => void;
}

export const DeleteCommentConfirmation: React.FC<
  DeleteCommentConfirmationProps
> = ({ isOpen, onClose, comment, onDelete }) => {
  const handleConfirm = () => {
    if (comment) {
      onDelete(comment.comment_id);
    }
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Delete Comment</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this comment? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
